package gr.tech.GRAttestation.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

val DefaultCarouselStyle = CssStyle {
    base {
        Modifier
            .borderRadius(8.px)
            .fillMaxSize()
            .overflow(Overflow.Hidden)
    }
}

@Composable
fun CarouselContainer(
    carouselId: String = "carouselId",
    imageNames: List<String>,
    currentImage: (String) -> Unit,
    apiFetchPath: String,
    modifier: Modifier = Modifier
) {
    Div(
        attrs = DefaultCarouselStyle.toModifier().id(carouselId).classNames("carousel", "carousel-dark", "slide")
            .then(modifier)
            .toAttrs {}
    ) {
        Div(
            attrs = Modifier.classNames("carousel-indicators").toAttrs {}
        ) {
            Button(
                attrs = Modifier.classNames("active").toAttrs{
                    type(ButtonType.Button)
                    attr("data-bs-target", "#${carouselId}")
                    attr("data-bs-slide-to", "0")
                    attr("aria-current", "true")
                    attr("aria-label", "image 1")
                }
            )

            imageNames.drop(1).forEachIndexed { index, _ ->
                Button(
                    attrs = Modifier.toAttrs{
                        type(ButtonType.Button)
                        attr("data-bs-target", "#${carouselId}")
                        attr("data-bs-slide-to", "${index+1}")
                        attr("aria-current", "true")
                        attr("aria-label", "image ${index+1}")
                    }
                )
            }
        }

        Div(
            attrs = Modifier.classNames("carousel-inner")
                .fillMaxHeight()
                .backgroundColor(Colors.WhiteSmoke)
                .toAttrs{}
        ) {
            if (imageNames.isNotEmpty()) {
                Div(
                    attrs = Modifier.classNames("carousel-item", "active")
                        .fillMaxSize()
                        .toAttrs()
                ) {
                    SpanText("Image 1")
                    Img(
                        src = "${apiFetchPath}?image=${imageNames[0]}",
                        attrs = Modifier
                            .height(100.percent)
                            .width(100.percent)
                            .objectFit(ObjectFit.Contain)
                            .toAttrs {
                                attr("data-image-name", imageNames[0])
                            }
                    )
                }

                imageNames.drop(1).forEachIndexed { index, img ->
                    Div(
                        attrs = Modifier.classNames("carousel-item")
                            .fillMaxSize()
                            .toAttrs {
                                attr("data-image-name", img)
                            }
                    ) {
                        SpanText("Image ${index+2}")
                        Img(
                            src = "${apiFetchPath}?image=${img}",
                            attrs = Modifier
                                .height(100.percent)
                                .width(100.percent)
                                .objectFit(ObjectFit.Contain)
                                .toAttrs {}
                        )
                    }
                }
            } else {
                Div(
                    attrs = Modifier.classNames("carousel-item", "active")
                        .toAttrs()
                ) {
                    Img(
                        src = "${apiFetchPath}?image=default.jpg",
                        attrs = Modifier
                            .width(autoLength)
                            .height(100.percent)
                            .objectFit(ObjectFit.Cover)
                            .toAttrs {}
                    )
                }
            }

        }
        // Previous button
        Button(
            attrs = Modifier.classNames("carousel-control-prev")
                .onClick {}
                .toAttrs {
                    attr("type", "button")
                    attr("data-bs-target", "#${carouselId}")
                    attr("data-bs-slide", "prev")
            }
        ) {
            Span(Modifier.classNames("carousel-control-prev-icon").toAttrs {
                attr("aria-hidden", "true")
            })
            Span(Modifier.classNames("visually-hidden").toAttrs()) {
                Text("Previous")
            }
        }

        // Next button
        Button(
            attrs = Modifier.classNames("carousel-control-next")
                .onClick {}
                .toAttrs {
                    attr("type", "button")
                    attr("data-bs-target", "#${carouselId}")
                    attr("data-bs-slide", "next")
            }
        ) {
            Span(Modifier.classNames("carousel-control-next-icon").toAttrs {
                attr("aria-hidden", "true")
            })
            Span(Modifier.classNames("visually-hidden").toAttrs()) {
                Text("Next")
            }
        }
    }
}